module.exports = __webpack_public_path__ + "static/media/friendsgiving.f6c0fb6d.jpg";